import { Col, Row } from "antd";
import React from "react";
import { Popup } from "../../../atoms/Popup";
import DashboardLayout from "../../../molecules/DashboardLayout";
import { SectionHeaderV2 } from "../../../organism/SectionHeaderV2";
import { ServiceRequestsGrid } from "./grid";
import { searchByOptions, useServiceRequestsSearch } from "./search";
import { useServiceRequestModal } from "./useServiceRequestModal";

export const ServiceRequestsModule = () => {
  const { selectedSearchBy, searchValue, handleSearch, handleChangeSearchBy } = useServiceRequestsSearch();
  const { popup, formType, isOpen, handleOpen, onClose } = useServiceRequestModal();

  return (
    <DashboardLayout>
      <Row gutter={24}>
        <Col span={24}>
          <SectionHeaderV2
            heading="Service Requests"
            addNewAction={() => handleOpen("add")}
            onSearch={handleSearch}
            onChangeSearchBy={handleChangeSearchBy}
            defaultSearch={searchValue}
            searchByOptions={searchByOptions}
          />
          <ServiceRequestsGrid handleOpen={handleOpen} selectedSearchBy={selectedSearchBy} searchValue={searchValue} />
          <Popup
            destroyOnClose
            width={popup[formType].width}
            visibility={isOpen}
            onCancel={onClose}
            style={{ padding: 10 }}
            title={popup[formType].title}
            content={popup[formType].content}
          />
        </Col>
      </Row>
    </DashboardLayout>
  );
};
